<template>
  <div class="root-container">
    <div v-if="!loading" class="weather-wrap">
      <div class="top-wrap">
        <span class="city-name">青岛</span>
        <div class="info">
          <van-icon
            :name="getWeatherIconByCode(realtimeData.skycon)"
          />
          <div class="temp">
            <span>{{ realtimeData.temperature }}°</span>
            <span>{{ getWeatherDescByCode(realtimeData.skycon) }}</span>
          </div>
          <div class="warning">
            <span v-if="alertData.content.length > 0" class="type-name">{{
              getAlertNameByCode(alertData.content[0].code)
            }}</span>
            <span
              class="aqi-name"
              :style="{
                color: getLevelColor(realtimeData.air_quality.aqi.chn),
              }"
            >{{ realtimeData.air_quality.description.chn }}</span>
          </div>
        </div>
        <span class="tip">{{ popText }}</span>
      </div>
      <div class="line" />
      <div class="bottom-wrap">
        <div
          v-for="(item, index) in dailyData.temperature"
          :key="index"
          class="item"
        >
          <span>{{ getDayTitle(index) }}</span>
          <van-icon
            :name="getWeatherIconByCode(dailyData.skycon[index].value)"
          />
          <span>{{ item.min }}°/{{ item.max }}°</span>
          <span v-if="false">良</span>
        </div>
      </div>
    </div>
    <div class="news-wrap">
      <span class="title">安全头条</span>
      <div v-for="item in newsDatas" :key="item.id" class="item">
        <span class="title">{{ item.title }}</span>
        <van-image
          :src="item.img"
          radius="8"
          width="110"
          height="55"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { getWeather } from '@/api/weather_caiyun.js'
export default {
  name: 'Home',
  data() {
    return {
      loading: true,
      popText: '', // 降水概率说明
      realtimeData: {}, // 实时天气数据
      dailyData: {}, // 逐天数据(3天)
      alertData: {}, // 预警数据
      newsDatas: [
        {
          id: 1,
          title: '[特别关注]台风来了怎么办',
          img: require('/static/img/weather_bg_small.png')
        },
        {
          id: 2,
          title: '[安全指南]雨天配送安全指南',
          img: require('/static/img/weather_bg_small.png')
        },
        {
          id: 3,
          title: '[漫说安全]商家出餐慢，我该怎么办',
          img: require('/static/img/weather_bg_small.png')
        },
        {
          id: 4,
          title:
            '[漫说安全]商家出餐慢，我该怎么办商家出餐慢，我该怎么办商家出餐慢，我该怎么办商家出餐慢，我该怎么办',
          img: require('/static/img/weather_bg_small.png')
        },
        {
          id: 5,
          title: '[漫说安全]商家出餐慢，我该怎么办',
          img: require('/static/img/weather_bg_small.png')
        },
        {
          id: 6,
          title: '[漫说安全]商家出餐慢，我该怎么办',
          img: require('/static/img/weather_bg_small.png')
        }
      ]
    }
  },
  created() {
    this.getWeather()
  },
  methods: {
    // 通用天气
    getWeather() {
      this.loading = true
      getWeather({
        alert: true,
        dailysteps: 3
      }).then((res) => {
        this.loading = false
        const result = res.result || {}
        this.realtimeData = result.realtime || {}
        this.dailyData = result.daily || {}
        this.alertData = result.alert || {}
        const minutelyData = result.minutely || {}
        this.popText = minutelyData.description
      })
    },
    // 天气图标
    getWeatherIconByCode(code) {
      return require(`/static/color-skycon/${code}.png`)
    },
    // 天气描述
    getWeatherDescByCode(code = 'CLEAR_DAY') {
      let desc
      switch (code) {
        case 'CLEAR_DAY':
        case 'CLEAR_NIGHT':
          desc = '晴'
          break
        case 'PARTLY_CLOUDY_DAY':
        case 'PARTLY_CLOUDY_NIGHT':
          desc = '多云'
          break
        case 'CLOUDY':
          desc = '阴'
          break
        case 'LIGHT_HAZE':
          desc = '轻度雾霾'
          break
        case 'MODERATE_HAZE':
          desc = '中度雾霾'
          break
        case 'HEAVY_HAZE':
          desc = '重度雾霾'
          break
        case 'LIGHT_RAIN':
          desc = '小雨'
          break
        case 'MODERATE_RAIN':
          desc = '中雨'
          break
        case 'HEAVY_RAIN':
          desc = '大雨'
          break
        case 'STORM_RAIN':
          desc = '暴雨'
          break
        case 'FOG':
          desc = '雾'
          break
        case 'LIGHT_SNOW':
          desc = '小雪'
          break
        case 'MODERATE_SNOW':
          desc = '中雪'
          break
        case 'HEAVY_SNOW':
          desc = '大雪'
          break
        case 'STORM_SNOW':
          desc = '暴雪'
          break
        case 'DUST':
          desc = '浮沉'
          break
        case 'SAND':
          desc = '沙尘'
          break
        case 'WIND':
          desc = '大风'
          break
      }
      return desc
    },
    // 预警类型名称
    getAlertNameByCode(code = 'unknow') {
      if (code == 'unknow') {
        return null
      }
      let name
      const type = code.slice(0, 2)
      const level = code.slice(2)
      switch (type) {
        case '01':
          name = '台风'
          break
        case '02':
          name = '暴雨'
          break
        case '03':
          name = '暴雪'
          break
        case '04':
          name = '寒潮'
          break
        case '05':
          name = '大风'
          break
        case '06':
          name = '沙尘暴'
          break
        case '07':
          name = '高温'
          break
        case '08':
          name = '干旱'
          break
        case '09':
          name = '雷电'
          break
        case '10':
          name = '冰雹'
          break
        case '11':
          name = '霜冻'
          break
        case '12':
          name = '大雾'
          break
        case '13':
          name = '霾'
          break
        case '14':
          name = '道路结冰'
          break
        case '15':
          name = '森林火灾'
          break
        case '16':
          name = '雷雨大风'
          break
      }
      switch (level) {
        case '01':
          name += '蓝色'
          break
        case '02':
          name += '黄色'
          break
        case '03':
          name += '橙色'
          break
        case '04':
          name += '红色'
          break
      }
      return `${name}预警`
    },

    // 逐天天气的日期描述
    getDayTitle(index) {
      if (index == 0) {
        return '今天'
      }
      if (index == 1) {
        return '明天'
      }
      if (index == 2) {
        return '后天'
      }
    },
    // 空气质量级别颜色
    getLevelColor(aqi) {
      const aqi_int = parseInt(aqi)
      if (aqi_int <= 50) {
        // 优
        return '#00FF00'
      } else if (aqi_int <= 100) {
        // 良
        return '#FFFF00'
      } else if (aqi_int <= 150) {
        // 轻度污染
        return '#FFA500'
      } else if (aqi_int <= 200) {
        // 中度污染
        return '#FF0000'
      } else if (aqi_int <= 300) {
        // 重度污染
        return '#800080'
      } else {
        // 严重污染
        return '#8B0000'
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.root-container {
  width: 100%;
  height: 100vh;
  background: #f5f5f5;
}
.weather-wrap {
  display: flex;
  flex-direction: column;
  padding: 8px;
  height: 300px;
  background-image: url("../../static/img/weather_bg_small.png");
  background-size: 100% 100%;
  background-repeat: no-repeat;
  span {
    font-size: 14px;
    color: white;
  }
  .top-wrap {
    margin: 0 20px;
    display: flex;
    flex: 1;
    flex-direction: column;
    .city-name {
      color: white;
      font-size: 15px;
      text-align: left;
    }
    .info {
      display: flex;
      align-items: center;
      margin-top: 20px;
      .temp {
        margin-left: 12px;
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        span:nth-of-type(1) {
          font-size: 20px;
        }
        span:nth-of-type(2) {
          font-size: 14px;
          margin-top: 6px;
        }
      }
      .warning {
        display: flex;
        flex-direction: column;
        margin-left: auto;
        align-items: flex-end;
        .type-name {
          border-radius: 16px;
          background: orange;
          padding: 2px 12px;
        }
        .aqi-name {
          margin-top: 4px;
        }
      }
    }
    .tip {
      margin-top: 20px;
      text-align: left;
    }
  }
  .bottom-wrap {
    display: flex;
    flex: 1;
    margin: 0 20px;
    align-items: center;
    .item {
      display: flex;
      flex: 1;
      flex-direction: column;
      span:nth-of-type(1) {
        margin-bottom: 4px;
      }
      span:nth-of-type(2) {
        margin-top: 4px;
        margin-bottom: 4px;
      }
    }
  }
  .line {
    height: 1px;
    background: #e1e1e1;
  }
}
.news-wrap {
  background: white;
  margin-top: 30px;
  border-radius: 8px;
  padding: 8px 16px;
  text-align: left;
  span {
    font-size: 14px;
  }
  .title {
    font-size: 16px;
  }
  .item {
    padding: 12px 0;
    margin-top: 12px;
    display: flex;
    justify-content: space-between;
    border-bottom: 1px solid #f5f5f5;
    .title {
      flex: 1;
      margin-right: 12px;
    }
  }
}
</style>
